import styled from 'styled-components';
import { styled as styledMUI } from '@mui/material/styles';
import Button from '@mui/material/Button';
import { colors } from '../../layout/css';

export const StyledButton = styledMUI(Button)((props) => ({
  color: props.primary ? colors.colorWhite : colors.admin.highlightTheme,
  backgroundColor: props.primary ? colors.admin.highlightTheme : colors.colorGrey04,
  '&:hover': {
    backgroundColor: props.primary ? colors.admin.lightTheme : colors.colorGrey05
  },
  padding: 10,
  fontWeight: 'strong'
}));

export const StyledH1 = styled.h1`
  color: ${(props) => props.color};
  font-size: ${(props) => props.size};
  font-weight: ${(props) => (props.bold ? 'bold' : 'normal')};
  padding-left: 1ch;
  margin: 3px;
`;

export const StyledH5 = styled.h5`
  color: ${(props) => props.color};
  font-size: ${(props) => props.size};
  font-weight: ${(props) => (props.bold ? 'bold' : 'normal')};
  margin: 10px;
  padding: 0;
`;

export const StyledH6 = styled.h6`
  color: ${(props) => props.color};
  font-size: ${(props) => props.size};
  font-weight: ${(props) => (props.bold ? 'bold' : 'normal')};
  margin: 0;
  padding: 0;
`;

export const ModalStyle = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 800,
  maxWidth: '80vw',
  maxHeight: '80vh',
  bgcolor: 'background.paper',
  boxShadow: 24,
  display: 'flex',
  flexDirection: 'column'
};

export const ModalHeaderStyle = {
  width: 800,
  maxWidth: '80vw',
  height: '50px',
  bgcolor: colors.colorBurgundy
};

export const ModalTopBodyStyle = { m: 1, marginTop: 1, maxHeight: '700px', overflow: 'auto' };

export const ModalTopContentStyle = { m: 2, marginTop: 2 };

export const ModalMiddleContentStyle = { m: 1, bgcolor: colors.colorWhite, width: 730, heigh: 100 };

export const ModalBottomContentStyle = { m: 1, p: 1, bgcolor: colors.colorGrey04, width: 760, heigh: 100 };

export const ItemStyle = {
  transform: 'translate(0px, 8px) scale(0.9)'
};

export const LoadingStyle = { display: 'flex', justifyContent: 'center', width: '100%', m: 2 };

export const ChipSuccessStyle = { borderRadius: 1, bgcolor: colors.colorGreen, width: '100%' };

export const ChipErrorStyle = { borderRadius: 1, bgcolor: colors.colorRed, width: '100%' };
